import React, { useState } from "react";
import { BsChevronDoubleDown, BsWhatsapp  } from "react-icons/bs";
import { Provider } from "./components/ui/provider";
import { Button, ButtonGroup } from "@chakra-ui/react"
import { ReactComponent as SiteImg } from './assets/site2.svg';
import { ReactComponent as OrganizationImg } from './assets/organization.svg';
import { ReactComponent as ContatoImg } from './assets/contato.svg';
import { ReactComponent as ProdutividadeImg } from './assets/produtividade.svg';
import { ReactComponent as LogoImg } from './assets/logo.svg';
import logo from './assets/logo.png';
import { MdClose } from "react-icons/md";
import useMediaQuery from '@mui/material/useMediaQuery';
const App = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const WIDTH_1000 = useMediaQuery("(max-width:1000px)")

  return (
    <Provider>
      <header style={styles.header}>
        <img src={logo} alt="Portal Net" style={styles.logoImg} />
        {
          !WIDTH_1000? (
            <nav>
              <ul style={styles.navCelular}>
                <li><a href="#inicio" style={styles.navLink}>Início</a></li>
                <li><a href="#benefits" style={styles.navLink}>Benefícios</a></li>
                <li><a href="#locais" style={styles.navLink}>Locais</a></li>
                <li><a href="#sobre" style={styles.navLink}>Sobre</a></li>
                <li><a href="https://wa.me/5555999368373"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Fale conosco pelo WhatsApp" style={styles.navLink}>Contato</a>
                </li>
              </ul>
            </nav>
          ) : (
            <div style={styles.menuToggle} onClick={toggleMenu}>
              {
                menuOpen? (
                  <MdClose color="#fff" size={38} />
                ) : (
                <>
                  <span style={styles.bar}></span>
                  <span style={styles.bar}></span>
                  <span style={styles.bar}></span>
                </>
                )
              }
              
            </div>
          )
        }
      </header>

      <nav>
        <ul style={{ ...styles.navList, ...(menuOpen ? styles.showMenu : {}) }}>
          <li><a href="#inicio" style={styles.navLink}>Início</a></li>
          <li><a href="#benefits" style={styles.navLink}>Benefícios</a></li>
          <li><a href="#locais" style={styles.navLink}>locais</a></li>
          <li><a href="#sobre" style={styles.navLink}>Sobre</a></li>
          <li><a href="https://wa.me/5555983239281"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Fale conosco pelo WhatsApp" style={styles.navLink}>Contato</a>
          </li>
        </ul>
      </nav>

      <section id="inicio" style={WIDTH_1000? styles.hero1600: styles.hero}>
        <SiteImg style={WIDTH_1000? styles.elementLeft1000: styles.elementLeft} alt="9 Bits Software" />
        <div style={{paddingTop: 40, display: 'flex', flexDirection: 'column'}}>
          <h1 style={WIDTH_1000? styles.heroTitleCelular: styles.heroTitle}>Provedor de Internet</h1>
          <h2 style={WIDTH_1000? styles.heroSubtitleCelular:styles.heroSubtitle}>
            Fibra Óptica e Via Rádio que você pode confiar.
          </h2>
          <div style={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', flexDirection: WIDTH_1000? "column-reverse": "row" }}>
            
            <a href="#benefits" style={styles.navLink}>
              <Button size="xl" rounded="full" style={{ marginTop: 20, backgroundColor: "#000", color: "#fff" }} colorPalette={"gray"}>
                  <BsChevronDoubleDown color="#fff" size="1em" />
                  O que oferecemos
                
              </Button>
            </a>

            <a href="https://wa.me/5555983239281"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Fale conosco pelo WhatsApp" style={styles.navLink}>
              <Button size="xl" rounded="full" style={{ marginTop: 20 }} colorPalette={"green"} >
                  <BsWhatsapp color="#fff" size="1em" />
                  Veja nossos planos
                
              </Button>
            </a>
          </div>

        </div>
      </section>

      <section id="benefits" style={WIDTH_1000? styles.benefits1000: styles.benefits}>
        <h1 style={styles.title}>O que oferecemos</h1>
        <div style={WIDTH_1000? { display: 'flex', flexDirection: 'column' }: { display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly' }}>
          <div style={{paddingTop: 40, display: 'flex', flexDirection: 'column', alignItems: 'center', maxWidth: 400, marginTop: 40} }>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', maxWidth: 200, maxHeight: 200, borderRadius: 300, backgroundColor: '#64728C' }}>
              <OrganizationImg loading="lazy" style={{ display: 'flex', alignSelf: 'center', flex: 0.7 }} alt="Organização" />

            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
              <h2 style={WIDTH_1000? styles.benefitTitleCelular: styles.benefitTitle}>Internet ilimitada</h2>
              <p style={WIDTH_1000? styles.benefitSubtitleCelular:styles.benefitSubtitle}>
                Alta velocidade e estabilidade com fibra óptica.
              </p>
            </div>

          </div>

          <div style={{paddingTop: 40, display: 'flex', flexDirection: 'column', alignItems: 'center', maxWidth: 400, marginTop: 40} }>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', maxWidth: 200, maxHeight: 200, borderRadius: 300, backgroundColor: '#64728C' }}>
              <ContatoImg loading="lazy" style={{ display: 'flex', alignSelf: 'center', flex: 0.7 }} alt="Contato" />

            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
              <h2 style={WIDTH_1000? styles.benefitTitleCelular: styles.benefitTitle}>Locais remotos</h2>
              <p style={WIDTH_1000? styles.benefitSubtitleCelular:styles.benefitSubtitle}>
                Atendemos locais de difícil acesso com internet via rádio, levando conexão a quem precisa.
              </p>
            </div>

          </div>

          <div style={{paddingTop: 40, display: 'flex', flexDirection: 'column', alignItems: 'center', maxWidth: 400, marginTop: 40} }>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', maxWidth: 200, maxHeight: 200, borderRadius: 300, backgroundColor: '#64728C' }}>
              <ProdutividadeImg loading="lazy" style={{ display: 'flex', alignSelf: 'center', flex: 0.7 }} alt="Produtividade" />

            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
              <h2 style={WIDTH_1000? styles.benefitTitleCelular: styles.benefitTitle}>Suporte</h2>
              <p style={WIDTH_1000? styles.benefitSubtitleCelular:styles.benefitSubtitle}>
                Resolvemos falhas de conexão de forma ágil e profissional.
              </p>
            </div>

          </div>
        </div>
        
      </section>

      <section id="locais" style={styles.section}>
        <h2 style={styles.sectionTitle}>Onde atendemos</h2>
        <div style={styles.testimonial}>
          <p>São Martinho</p>
        </div>
        <div style={styles.testimonial}>
          <p>Alegria</p>
        </div>
        <div style={styles.testimonial}>
          <p>São Valério</p>
        </div>
      </section>

      <section id="sobre" style={WIDTH_1000? styles.sobre1600: styles.sobre}>
        <img src={logo} aalt="Somos a Portal Net" loading="lazy" style={WIDTH_1000? styles.elementLeft1000: styles.elementLeftBottom} />
        <div style={{paddingTop: 40, display: 'flex', flexDirection: 'column'}}>
          <h2 style={WIDTH_1000? styles.sobreTitleCelular: styles.sobreTitle}>Quem somos</h2>
          <p style={WIDTH_1000? styles.sobreSubtitleCelular:styles.sobreSubtitle}>
            CNPJ: 08.097.944/0001-30
          </p>
          <p style={WIDTH_1000? styles.sobreSubtitleCelular:styles.sobreSubtitle}>
            E-mail: portalnet@portalnetinformatica.com.br
          </p>
          <p style={WIDTH_1000? styles.sobreSubtitleCelular:styles.sobreSubtitle}>
            Endereço: Avenida Getúlio Vargas, 764, centro de São Martinho/RS - 98.690-000
          </p>
        </div>
      </section>

      <footer id="contato" style={styles.footer}>
        <p>© FUHR & FELTES LTDA. Todos os direitos reservados.
          CNPJ: 08.097.944/0001-30
          contatos: (55) 3533-1715 | (55) 9 8423-9281
        </p>
        <a href="https://docs.google.com/document/d/1VL2rC5G_1coA-nUFq4AdQwZkaIIowHnf-TUG_kbomKg/edit?usp=sharing">política de Privacidade</a>
      </footer>

      <a
        href="https://wa.me/5555983239281"
        style={styles.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Fale conosco pelo WhatsApp"
      >
        <BsWhatsapp />
      </a>
    </Provider>
  );
};

const styles = {
  header: {
    zIndex: 999,
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    background: "#ffffffff",
    padding: "8px",
    display: "flex",
    flexDirection: 'row',
    justifyContent: "space-between",
    alignItems: "center",
  },
  logoImg: {
    height: 60,
  },
  logo: {
    fontSize: "1.5em",
    color: "#fff",
  },
  menuToggle: {
    display: "flex",
    flexDirection: "column",
    gap: "5px",
    cursor: "pointer",
  },
  bar: {
    background: "#000",
    height: "3px",
    width: "25px",
    
  },
  navList: {
    height: 200,
    justifyContent: 'space-evenly',
    listStyle: "none",
    display: "none",
    flexDirection: "column",
    background: "#e6e6e6ff",
    position: "fixed",
    top: "70px",
    right: 0,
    padding: "10px",
    borderRadius: "0px",
    zIndex: 2,
  },
  navCelular: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  showMenu: {
    display: "flex",
  },
  navLink: {
    color: "#000",
    textDecoration: "none",
    margin: "10px 0",
    fontWeight: "bold",
    padding: 20
  },
  hero: {
    height: '90vh',
    display: "flex",
    flexDirection: 'row',
    backgroundColor: "#fff",
    padding: "100px 20px",
    justifyContent: 'space-evenly',
    textAlign: "center",
    color: "#3D7FFA",
  },
  hero1600: {
    display: "flex",
    flexDirection: 'column',
    backgroundColor: "#fff",
    padding: "100px 20px",
    textAlign: "center",
    color: "#3D7FFA",
    justifyContent: 'space-between',
  },
  heroTitle: {
    fontSize: "2.5em",
  },
  heroTitleCelular: {
    fontSize: "1.5em",
  },
  heroSubtitle: {
    fontSize: "1.2em",
    color: "#333",
    fontWeight: 'bold'
  },
  heroSubtitleCelular: {
    fontSize: "1em",
    color: "#777",
    fontWeight: 'bold'
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: "60px 20px",
    width: "100%",
    backgroundColor: '#1F2634',
    color: "#fff",
  },
  sectionTitle: {
    textAlign: "center",
    fontSize: "2em",
    marginBottom: "30px",
  },
  testimonial: {
    width: '100%',
    maxWidth: '800px',
    background: "#1a1a1a",
    padding: "20px",
    borderRadius: "10px",
    marginBottom: "20px",
    boxShadow: "0 0 10px rgba(0,0,0,0.3)",
  },
  stars: {
    color: "gold",
  },
  footer: {
    background: "#111",
    textAlign: "center",
    padding: "30px",
    color: "#ccc",
  },
  whatsapp: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    background: "#25d366",
    color: "white",
    padding: "15px",
    borderRadius: "50%",
    fontSize: "24px",
    textDecoration: "none",
    boxShadow: "0 4px 6px rgba(0,0,0,0.3)",
    zIndex: 10,
  },
  elementLeft: {
    width: '50%',
  },
  elementLeftBottom: {
    width: '50%',
    maxHeight: 200
  },
  elementLeft1000: {
    width: '80%',
    height: 200,
    alignSelf: 'center'
  },
  title: {
    fontSize: '2em',
    textAlign: 'center',
    color: '#7D95C1',
  },
  benefits: {
    height: '90vh',
    display: "flex",
    flexDirection: 'column',
    backgroundColor: "#192233",
    padding: "100px 20px",
    justifyContent: 'space-evenly',
    textAlign: "center",
    color: "#3D7FFA",
  },
  benefits1000: {
    display: "flex",
    flexDirection: 'column',
    backgroundColor: "#192233",
    padding: "100px 20px",
    textAlign: "center",
    color: "#3D7FFA",
    justifyContent: 'center',
    alignItems: 'center'
  },
  benefitTitle: {
    paddingLeft: 20,
    fontSize: "1.5em",
    color: '#6A9DFA'
  },
  benefitTitleCelular: {
    paddingTop: 20,
    fontSize: "1.2em",
    color: '#6A9DFA'
  },
  benefitSubtitle: {
    textAlign: 'left',
    paddingLeft: 20,
    fontSize: "1.2em",
    color: "#fff",
  },
  benefitSubtitleCelular: {
    textAlign: 'left',
    fontSize: "1em",
    color: "#fff",
  },
  sobre: {
    height: '90vh',
    display: "flex",
    flexDirection: 'row',
    backgroundColor: "#090909",
    padding: "100px 80px",
    justifyContent: 'space-evenly',
    textAlign: "center",
    color: "#3D7FFA",
  },
  sobre1600: {
    display: "flex",
    flexDirection: 'column',
    backgroundColor: "#090909",
    padding: "100px 20px",
    textAlign: "center",
    color: "#3D7FFA",
    justifyContent: 'space-between',
  },
  sobreTitle: {
    fontSize: "2.5em",
  },
  sobreTitleCelular: {
    fontSize: "1.5em",
  },
  sobreSubtitle: {
    display: 'flex',
    textIdent: '2em',
    fontSize: "1.2em",
    color: "#ccc",
    fontWeight: 'normal',
    padding: "0 40px",
    textAlign: 'left',
    alignSelf: 'center'
  },
  sobreSubtitleCelular: {
    textIdent: '2em',
    display: 'flex',
    alignSelf: 'center',
    fontSize: "1em",
    color: "#ccc",
    fontWeight: 'normal',
    paddingHorizontal: "0 20px",
    textAlign: 'left'
  },
};

export default App;
